import type { ButtonProps } from '@corratech/pylot-ui/src/Button'
import Button from '@corratech/pylot-ui/src/Button'
import { isDark } from '@corratech/pylot-utils'
import { OptionType } from '@pylot-data/hooks/product/use-product-ui'
import cn from 'classnames'
import { useTranslation } from 'next-i18next/pages'
import type { FC } from 'react'
import s from './Swatch.module.scss'

interface SwatchProps {
    active?: boolean
    className?: string
    label?: string
    color?: string
    url?: string
    optionType?: OptionType | null
    isCircle?: boolean
    displaySwatchOptionLabel?: boolean
}

const Swatch: FC<SwatchProps & ButtonProps> = ({
    className,
    color = '',
    url = '',
    label,
    active,
    optionType = OptionType.TextSwatch,
    isCircle = false,
    disabled = false,
    displaySwatchOptionLabel = false,
    ...props
}) => {
    label = label?.toLowerCase()

    const isTextSwatch = !(url !== '' || color !== '')

    const rootClassName = cn(
        s.root,
        {
            [s.circle]: optionType === OptionType.VisualSwatch || isCircle,
            [s.text]:
                optionType === OptionType.TextSwatch ||
                optionType === OptionType.Other,
            [s.active]: active,
            [s.color]: color,
            [s.dark]: color ? isDark(color) : false
        },
        className
    )
    const { t } = useTranslation('common')

    const bgColorStyles = color ? { backgroundColor: color } : {}
    const bgImageStyles = url ? { backgroundImage: `url('${url}')` } : {}
    return (
        <span
            className={cn(
                s['swatch-item'],
                'swatch-item',
                !isTextSwatch && s['swatch-item-color'],
                isTextSwatch ? 'text-swatch' : 'visual-swatch',
                disabled && s['swatch-item-disabled'],
                disabled && 'swatch-item-disabled',
                !isTextSwatch && active && [s.selected],
                active && 'selected'
            )}
        >
            <Button
                className={rootClassName}
                style={{ ...bgColorStyles, ...bgImageStyles }}
                aria-label={t('Variant Swatch')}
                disabled={disabled}
                aria-disabled={disabled}
                {...props}
            >
                {isTextSwatch && label}
            </Button>
            {!isTextSwatch && displaySwatchOptionLabel && (
                <span className="swatch-label-text">{label}</span>
            )}
        </span>
    )
}

export default Swatch
